import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=e4fb6c84"
import script from "./EditInfo.vue?vue&type=script&lang=js"
export * from "./EditInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports